import { render, staticRenderFns } from "./descBtn.vue?vue&type=template&id=0a2e92b2&scoped=true&"
import script from "./descBtn.vue?vue&type=script&lang=js&"
export * from "./descBtn.vue?vue&type=script&lang=js&"
import style0 from "./descBtn.vue?vue&type=style&index=0&id=0a2e92b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2e92b2",
  null
  
)

export default component.exports